/**
 * Волна B (docs/MIGRATION_ROUTER.md §5). Было: <CacheDataRoute path='/sbp-promotion'>.
 */
import { createFileRoute } from '@tanstack/react-router';
import CacheDataRoute from '../CacheDataRoute';
import SBPLanding from '@routes/SBPLanding';

export const Route = createFileRoute('/sbp-promotion')({
  staticData: { layout: { landingFooter: true } },
  component: () => (
    <CacheDataRoute component={SBPLanding} path='/sbp-promotion' />
  )
});
